export const SECTION_SLUGS = {
  A: "zemedelstvi-lesnictvi-rybarstvi",
  B: "tezba-a-dobyvani",
  C: "zpracovatelsky-prumysl",
  D: "vyroba-a-rozvod-elektriny-plynu-tepla-a-klimatizovaneho-vzduchu",
  E: "zasobovani-vodou-odpady-a-sanace",
  F: "stavebnictvi",
  G: "velkoobchod-a-maloobchod-opravy-motorovych-vozidel",
  H: "doprava-a-skladovani",
  I: "ubytovani-stravovani-a-pohostinstvi",
  J: "informacni-a-komunikacni-cinnosti",
  K: "peneznictvi-a-pojistovnictvi",
  L: "cinnosti-v-oblasti-nemovitosti",
  M: "profesni-vedecke-a-technicke-cinnosti",
  N: "administrativni-a-podpurne-cinnosti",
  P: "vzdelavani",
  Q: "zdravotni-a-socialni-pece",
  R: "kulturni-zabavni-a-rekreacni-cinnosti",
  S: "ostatni-cinnosti"
};

export const INDICATOR_SLUGS = {
  ROA: "roa",
  ROE: "roe",
  ROS: "ros",
  "EBITDA marže": "ebitda-marze",
  "Provozní marže": "provozni-marze",
  "Likvidita běžná": "likvidita-bezna",
  "Likvidita pohotová": "likvidita-pohotova",
  "Likvidita okamžitá": "likvidita-okamzita",
  "Zadluženost celková": "zadluzenost-celkova",
  "Zadluženost dlouhodobá": "zadluzenost-dlouhodoba",
  "Obrat aktiv": "obrat-aktiv",
  "Obrat zásob": "obrat-zasob",
  "Doba obratu pohledávek": "doba-obratu-pohledavek",
  "Doba obratu závazků": "doba-obratu-zavazku",
  "Cyklus peněz": "cyklus-penez",
  "Marže přidané hodnoty": "marze-pridane-hodnoty",
  "Osobní náklady / přidaná hodnota": "osobni-naklady-na-pridanou-hodnotu",
  "Podíl osobních nákladů": "podil-osobnich-nakladu",
  "Meziroční růst tržeb": "mezirocni-rust-trzeb"
};

const buildReverseMap = (mapping) =>
  Object.entries(mapping).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});

const SECTION_BY_SLUG = buildReverseMap(SECTION_SLUGS);

const SECTION_SLUG_ALIASES = {
  a: "A",
  b: "B",
  c: "C",
  d: "D",
  e: "E",
  f: "F",
  g: "G",
  h: "H",
  i: "I",
  j: "J",
  k: "K",
  l: "L",
  m: "M",
  n: "N",
  p: "P",
  q: "Q",
  r: "R",
  s: "S"
};

const INDICATOR_BY_SLUG = buildReverseMap(INDICATOR_SLUGS);

const normalizeSlug = (slug) => (slug || "").trim().toLowerCase();

export const sectionToSlug = (section) => SECTION_SLUGS[section] || "";

export const slugToSection = (slug) => {
  const normalized = normalizeSlug(slug);
  return SECTION_BY_SLUG[normalized] || SECTION_SLUG_ALIASES[normalized] || "";
};

export const indicatorToSlug = (indicator) => INDICATOR_SLUGS[indicator] || "";
export const slugToIndicator = (slug) => INDICATOR_BY_SLUG[normalizeSlug(slug)] || "";
